<!--
 * @Author: your name
 * @Date: 2020-08-24 19:10:33
 * @LastEditTime: 2020-09-23 16:55:47
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \Web\JiYun.Mobile\src\views\leaderTerminal\DataBulletin\stockStatus.vue
-->
<template>
    <div class="stockStatus">
        <div class="search-conditions">
            <!-- <span class="time-con" @click="showCalendarPop=true">
                <span>{{ date }}</span>
            </span> -->
            <span class="org" @click="showOrgPop=true">
                <span class="org-name">{{ orgName }}</span>
            </span>
        </div>
        <div class="stock">
            <div
                class="item item0"
                v-for="(item, index) in data"
                :key="index"
                :class="`item${index%6}`"
            >
                <div class="cloum">
                    <h4>{{ item.material_category_name }}</h4>
                    <div class="liquidFill" :id="`liquidFill${index}`"></div>
                </div>
                <div class="cloum">
                    <div class="unit">
                        单位：(吨)
                    </div>
                    <div class="row">
                        <p class="lable-text">
                            最大库存:
                        </p>
                        <p class="num">
                            {{ item.volume_max }}
                        </p>
                    </div>
                    <div class="row">
                        <p class="lable-text">
                            当前库存:
                        </p>
                        <p class="num">
                            {{ item.volume_theory }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <van-popup v-model="showCalendarPop" position="bottom" :style="{ height: '50%' }">
            <van-datetime-picker
                v-model="currentDate"
                type="year-month"
                title="选择年月"
                @confirm="confirmDate"
                @cancel="cancelDate"
            ></van-datetime-picker>
        </van-popup>
        <van-popup v-model="showOrgPop" position="bottom" :style="{ height: '50%' }">
            <van-picker
                show-toolbar
                title="请选择"
                :columns="columns"
                @confirm="confirmOrg"
                @cancel="cancelOrg"
            ></van-picker>
        </van-popup>
    </div>
</template>

<script>
import 'echarts-liquidfill';
export default {
    components: {},
    props: {},
    data() {
        return {
            // 选择时间
            showCalendarPop: false,
            // 选择组织结构
            showOrgPop: false,
            // 当前日期
            date: '',
            // 选中组织结构
            orgName: '全部',
            columns: [
                {
                    text: '全部',
                    children: [],
                },
            ],
            // 图表数据
            data: {},
            // 组织机构
            orgData: [],
            currentDate: new Date(),
            yun_yq_id: '',
            pian_q_id: '',
            // 水球颜色值
            colorData: ['#5588F1', '#FA8436', '#8B6BEE', '#21BDCC', '#F1B000', '#8CCF44'],
        };
    },
    watch: {},
    computed: {},
    created() {},
    mounted() {
        this.init();
    },
    methods: {
        init() {
            const date = new Date();
            const year = date.getFullYear();
            const month = date.getMonth() + 1;
            this.date = year + '-' + month;
            this.getOrg();
            this.getSaleday();
            // this.drawLiuQiu({ stock_rate: 0.3 }, 0);
            // this.drawLiuQiu({ stock_rate: 0.2 }, 1);
            // this.drawLiuQiu({ stock_rate: 0.5 }, 2);
            // this.drawLiuQiu({ stock_rate: 0.6 }, 3);
        },
        async getOrg() {
            const yyq = await this.getOrgApi();
            if (yyq) {
                const res = yyq.map(item => {
                    item.text = item.dic_name;
                    if (item.children) {
                        item.children = item.children.map(v => {
                            v.text = v.dic_name;
                            return v;
                        });
                    } else {
                        item.children = [];
                    }
                    return item;
                });
                this.orgData = res;
                this.columns[0].children = this.orgData;
            }
        },
        async getSaleday() {
            const res = await this.getSaledayApi();
            if (res) {
                this.data = res;
                this.$nextTick(() => {
                    this.data.map((item, index) => {
                        this.drawLiuQiu({ stock_rate: item.volume_scale }, index);
                    });
                });
                // this.initLineChart();
                // this.initPieChart();
            }
        },

        // 获取数据    
        getSaledayApi() {
            const data = {
                year_month: this.date,
                yun_yq_id: this.yun_yq_id,
                pian_q_id: this.pian_q_id,
            };
            const path = '/interfaceApi/report/productmaterialconsume/statisticalstockmaterialtype';
            return this.$axios.$post(path, data, { defEx: true });
        },
        // 获取组织结构    
        getOrgApi() {
            const path = '/interfaceApi/report/dictionary/get_dictionary_tree?group_code=jt_data_express_tenant&isAddSelect=true';
            return this.$axios.$get(path, { defEx: true });
        },
        confirmDate(value) {
            this.showCalendarPop = false;
            this.date = this.formatDate(value);
            this.getSaleday();
        },
        cancelDate() {
            this.showCalendarPop = false;
        },
        formatDate(date) {
            date = new Date(date);
            const y = date.getFullYear();
            let m = date.getMonth() + 1;
            m = m < 10 ? '0' + m : m;
            return y + '-' + m;
        },
        confirmOrg(value) {
            this.showOrgPop = false;

            this.orgName = '';
            if (value[0]) {
                this.orgName += value[0];
            }
            if (value[1] && value[1] !== '请选择') {
                this.orgName = value[1];
            }
            if (value[2] && value[2] !== '请选择') {
                this.orgName += '-' + value[2];
            }

            if (value[2] && value[2] !== '请选择') {
                this.orgData.map(item => {
                    if (item.children) {
                        item.children.map(v => {
                            if (v.text === value[2]) {
                                this.pian_q_id = v.dic_code;
                            }
                        });
                    }
                });
                this.yun_yq_id = '';
            } else if (value[1] && value[1] !== '请选择') {
                this.orgData.map(item => {
                    if (item.text === value[1]) {
                        this.yun_yq_id = item.dic_code;
                    }
                });
                this.pian_q_id = '';
            } else {
                this.yun_yq_id = '';
                this.pian_q_id = '';
            }
            this.getSaleday();
        },
        cancelOrg() {
            this.showOrgPop = false;
        },
        // 画水球
        drawLiuQiu(itemData, index) {
            // 基于准备好的dom，初始化echarts实例
            const myChart = this.$echarts.init(document.getElementById('liquidFill' + index));
            // 指定图表的配置项和数据
            const option = {
                series: [{
                    type: 'liquidFill',
                    data: [itemData.stock_rate],
                    radius: '90%',
                    // 水球颜色
                    color: [this.colorData[index % 6]],
                    outline: {
                        borderDistance: 2,
                        itemStyle: {
                            borderWidth: 2,
                            borderColor: this.colorData[index % 6],
                        },
                    },
                    label: {
                        normal: {
                            color: this.colorData[index % 6],
                            insideColor: '#fff',
                            fontSize: 14,
                        },
                    },
                    // 内图 背景色 边
                    backgroundStyle: {
                        color: '#fff',
                    },
                }],
            };
            // 使用刚指定的配置项和数据显示图表。
            myChart.setOption(option);
        },
    },
};
</script>
<style lang="stylus" scoped>
.stockStatus
    background #fff
    width 100%
    height 100%
    padding 10rpx
    .search-conditions
        font-size 16rpx
        height 45rpx
        box-shadow 1px 1px 4px 0px rgba(0,0,0,0.2)
        border-radius 4rpx
        padding 10rpx 20rpx
        display flex
        justify-content space-around
        line-height 25rpx
        .time-con
            position relative
            flex 1
            text-align center
            &:after
                content ''
                position absolute
                right 10rpx
                height 15rpx
                border-right 1px solid #D7D7D7
                margin-top 5rpx
        .iconfont
            font-size 14rpx
            color #979EA7
            margin-left 5rpx
        .org
            flex 1
            text-align center
            .org-name
                color #3495FB
    .stock
        height calc(100% - 55rpx)
        margin-top 10rpx
        padding-top 1px
        overflow-y auto
        .item
            float left
            width calc(50% - 6px)
            min-height 112rpx
            box-shadow 1px 1px 4px 0px rgba(0,0,0,0.2)
            border-radius 4px
            box-sizing border-box
            margin-bottom 10rpx
            display flex
            padding 10rpx
            justify-content space-between
            &:nth-of-type(odd)
                margin-right 10rpx
                margin-left 1px
            .liquidFill
                height calc(100% - 20rpx)
            .cloum
                flex 1
                flex-shrink 0
                width 50%
                h4
                    margin-bottom 5rpx
                    padding-left 10rpx
                .unit
                    font-size 12rpx
                    color #979EA7
                    text-align center
                    margin-bottom 5rpx
                .row
                    text-align center
                    margin-bottom 5rpx
                    .num
                        font-size 14rpx
                    .lable-text
                        font-size 12rpx
            &.item0
                .row
                    .num
                        color #5588F1
            &.item1
                .row
                    .num
                        color #FA8436
            &.item2
                .row
                    .num
                        color #8B6BEE
            &.item3
                .row
                    .num
                        color #21BDCC
            &.item4
                .row
                    .num
                        color #F1B000
            &.item5
                .row
                    .num
                        color #8CCF44
</style>